'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildMetadataWithRichText;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _sanitize = require('conversations-schema/sanitize');

var _buildQuickReply = require('./buildQuickReply');

var _buildQuickReply2 = _interopRequireDefault(_buildQuickReply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildMetadataWithRichText() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var Record = arguments[1];

  var metadata = Record(props);
  var cleanedText = (0, _sanitize.clean)((0, _get2.default)('richText', props)) || null;
  var quickReplyRecord = (0, _buildQuickReply2.default)((0, _get2.default)('quickReply', props)) || null;

  return metadata.set('richText', cleanedText).set('quickReply', quickReplyRecord);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/factories/PubNubMessageFactory/buildMetadataWithRichText.js
// module id = 303
// module chunks = 0 1